import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { NoopNgZone } from '@recruitee/common';
import { PHRASE_APP_TRANSLATIONS } from '@recruitee/i18n';

import { RtoAppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrap = async () => {
  const ngModule: NgModuleRef<any> = await platformBrowserDynamic([
    { provide: PHRASE_APP_TRANSLATIONS, useValue: [{ en: {} }] },
  ]).bootstrapModule(RtoAppModule, {
    ngZone: new NoopNgZone(),
  });

  return ngModule;
};

bootstrap();
